import { render, staticRenderFns } from "./CalendarSlot.vue?vue&type=template&id=f06163d4&scoped=true&"
import script from "./CalendarSlot.vue?vue&type=script&lang=js&"
export * from "./CalendarSlot.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSlot.vue?vue&type=style&index=0&id=f06163d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06163d4",
  null
  
)

export default component.exports